import { progressKey, type SkillId } from "../../content/types.ts";
import type { IntroStep } from "../../lesson.ts";
import { uid } from "../../rng.ts";
import { register } from "../registry.ts";
import type { BuildContext } from "../registry.ts";

export function makeIntro(itemId: string, skill: SkillId): IntroStep {
	return { kind: "intro", key: progressKey(itemId, skill), uid: uid() };
}

register<IntroStep, string>({
	id: "intro",
	appliesTo: ["letter", "word"],
	build(ctx: BuildContext) {
		// See choice/logic.ts's build() for why skill travels via options rather than
		// BuildContext itself.
		return makeIntro(ctx.itemId, ctx.options.skill as SkillId);
	},
	grade() {
		return true;
	},
	graded: false,
	byEar: () => false, // it plays, but nothing is asked
	heard: () => false,
	keys: (step) => [step.key],
	// Every capitals-unit step draws letters whose `upper` must exist, which
	// is exactly what capitalOf would otherwise throw on at build time.
	requires: (cfg) => (cfg.skill === "upper" ? ["capital"] : []),
});
